import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from './ui/alert-dialog';
import { buttonVariants } from './ui/button';
import { cn } from '../utils';

export default function ConfirmDialog({
    title,
    description,
    cancel,
    action,
    handleAction,
    children,
    variant = 'confirm',
}) {
    const actionClassName = variant === 'destructive'
        ? buttonVariants({ variant: 'destructive' })
        : cn(buttonVariants(), 'bg-yavrio-green hover:bg-yavrio-green-dark text-white');

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                {children}
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        {title}
                    </AlertDialogTitle>
                </AlertDialogHeader>
                <AlertDialogDescription>
                    {description}
                </AlertDialogDescription>
                <AlertDialogFooter>
                    <AlertDialogCancel>
                        {cancel}
                    </AlertDialogCancel>
                    <AlertDialogAction onClick={handleAction} className={actionClassName}>
                        {action}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
